module.exports = __webpack_public_path__ + "img/coupon-get-bg.06b904d0.png";